import React from "react";
import "./../../payout.scss";
import "./../payout/styles/payoutRecipients.scss";

export default function TeacherTableHeader({ columns }) {
  let jsxCols = columns?.reduce((r, col) => {
    r.push(
      <div
        key={col.header}
        className={`col ${col.leftSide ? "left-side" : ""} ${col.lastCol ? "last-col" : ""}`}
        style={{ width: col.width }}
      >
        {col.header}
      </div>
    );
    return r;
  }, []);

  return <div className={"header-row"}>{jsxCols}</div>;
}
